// BaseRailOrder.js

export {
  BASE_RAIL_ORDER_SETTING_KEY,
  LEGACY_WORKSPACE_RAIL_ORDER_SETTING_KEY,
} from 'utilities/baseSettingsKeys';

export function normalizeBaseRailOrderKeys(orderKeys) {
  if (!Array.isArray(orderKeys)) return [];

  const seen = new Set();
  const normalized = [];

  orderKeys.forEach((key) => {
    const cleanedKey = String(key || '').trim();
    if (!cleanedKey || seen.has(cleanedKey)) return;
    seen.add(cleanedKey);
    normalized.push(cleanedKey);
  });

  return normalized;
}

export function buildBaseRailOrderKeys(bases, orderKeys, getBaseKey) {
  const resolveKey = typeof getBaseKey === 'function'
    ? getBaseKey
    : (base) => String(base?.key || base?.id || '').trim();

  const savedOrder = normalizeBaseRailOrderKeys(orderKeys);
  const baseKeys = (Array.isArray(bases) ? bases : [])
    .map((base) => resolveKey(base))
    .filter(Boolean);

  const baseKeySet = new Set(baseKeys);
  const nextOrder = savedOrder.filter((key) => baseKeySet.has(key));

  baseKeys.forEach((key) => {
    if (!nextOrder.includes(key)) {
      nextOrder.push(key);
    }
  });

  return nextOrder;
}

export function sortBasesByRailOrder(bases, orderKeys, getBaseKey) {
  const resolveKey = typeof getBaseKey === 'function'
    ? getBaseKey
    : (base) => String(base?.key || base?.id || '').trim();

  const rows = Array.isArray(bases) ? bases : [];
  const orderIndexByKey = new Map(
    buildBaseRailOrderKeys(rows, orderKeys, resolveKey).map((key, index) => [key, index]),
  );

  return [...rows].sort((left, right) => {
    const leftKey = resolveKey(left);
    const rightKey = resolveKey(right);
    const leftIndex = orderIndexByKey.get(leftKey);
    const rightIndex = orderIndexByKey.get(rightKey);

    if (leftIndex == null && rightIndex == null) return 0;
    if (leftIndex == null) return 1;
    if (rightIndex == null) return -1;
    return leftIndex - rightIndex;
  });
}

export function moveBaseInRailOrder(orderKeys, fromKey, toKey) {
  const currentOrder = normalizeBaseRailOrderKeys(orderKeys);
  const normalizedFromKey = String(fromKey || '').trim();
  const normalizedToKey = String(toKey || '').trim();

  if (!normalizedFromKey || !normalizedToKey || normalizedFromKey === normalizedToKey) {
    return null;
  }

  const fromIndex = currentOrder.indexOf(normalizedFromKey);
  const toIndex = currentOrder.indexOf(normalizedToKey);

  if (fromIndex < 0 || toIndex < 0) return null;

  const nextOrder = [...currentOrder];
  const [movedKey] = nextOrder.splice(fromIndex, 1);
  nextOrder.splice(toIndex, 0, movedKey);
  return nextOrder;
}
